import { render, staticRenderFns } from "./service-stock.html?vue&type=template&id=971676aa&scoped=true&external"
import script from "./service-stock.js?vue&type=script&lang=js&external"
export * from "./service-stock.js?vue&type=script&lang=js&external"
import style0 from "./service-stock.scss?vue&type=style&index=0&id=971676aa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971676aa",
  null
  
)

export default component.exports